import Glide, {
  Autoplay,
  Breakpoints,
  Swipe,
} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.core.scss'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.theme.scss'; // tslint:disable-line

import './usp.pcss';

export class Usp {
  glide: Glide;

  constructor(uspBanner: HTMLElement) {
    if (uspBanner) {
      this.glide = new Glide('.glide-usp', {
        autoplay: false,
        bound: true,
        breakpoints: {
          801: {
            perView: 3,
          },
          800: {
            perView: 1,
          },
        },
        classes: {
          activeSlide: 'usp__slide--active',
        },
        perView: 3,
        type: 'slider',
      }).mount({
        Autoplay,
        Breakpoints,
        Swipe,
      });
    }
  }

  destroy() {
    this.glide.destroy();
  }
}
